import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText } from '@material-ui/core';
import {
  IconButton,
  ListItem,
  makeStyles,
  NamedColors,
  Select,
} from '@knockrentals/knock-shared-web';
import { DeleteSvgIcon } from '../../../../Components/Icons';
import { MaxIncome } from './MaxIncome';

const useStyles = makeStyles({
  deleteButton: {
    color: NamedColors.apple[600],
    marginBottom: 'auto',
    '& .MuiSvgIcon-root': {
      height: '21px',
      width: '21px',
    },
  },
  eligibleQualification: {
    alignItems: 'normal',
    '& .MuiFormControl-root': {
      marginBottom: '8px',
    },
  },
  income: {
    marginLeft: '10px',
    width: '200px',
  },
  occupants: {
    width: '200px',
  },
});

const EligibleQualification = ({
  clearValidationErrorMessage,
  deleteEligibleQualification,
  errorMessages,
  maximumIncome,
  occupants,
  personOptions,
  updateEligibleQualification,
}) => {
  const classes = useStyles();

  const handleDeleteOnClick = () => {
    deleteEligibleQualification(maximumIncome, occupants);
  };

  const maxIncomeOnChange = (maxIncome) => {
    updateEligibleQualification({ maximum_income: maxIncome });
  };

  const selectOccupantsOnChange = (e) => {
    updateEligibleQualification({
      [e.target.name]: e.target.value,
    });
  };

  const handleOccupantsOnFocus = () => {
    if (errorMessages.occupants) {
      clearValidationErrorMessage('occupants');
    }
  };

  return (
    <ListItem className={classes.eligibleQualification} dense disableGutters>
      <FormControl>
        <Select
          aria-label="occupants"
          className={classes.occupants}
          error={Boolean(errorMessages.occupants)}
          name="occupants"
          noForm
          onFocus={handleOccupantsOnFocus}
          onChange={selectOccupantsOnChange}
          options={personOptions}
          value={occupants || ''}
        />

        {errorMessages.occupants && (
          <FormHelperText error>{errorMessages.occupants}</FormHelperText>
        )}
      </FormControl>

      <MaxIncome
        className={classes.income}
        clearValidationErrorMessage={() =>
          clearValidationErrorMessage('maxIncome')
        }
        errorMessage={errorMessages.maxIncome}
        maxIncome={maximumIncome || ''}
        maxIncomeOnChange={maxIncomeOnChange}
      />

      <IconButton
        aria-label="delete row"
        className={classes.deleteButton}
        onClick={handleDeleteOnClick}
      >
        <DeleteSvgIcon color="error" height="21px" width="21px" />
      </IconButton>
    </ListItem>
  );
};

EligibleQualification.propTypes = {
  clearValidationErrorMessage: PropTypes.func,
  deleteEligibleQualification: PropTypes.func,
  errorMessages: PropTypes.shape({
    maxIncome: PropTypes.string,
    occupants: PropTypes.string,
  }),
  maximumIncome: PropTypes.string,
  occupants: PropTypes.string,
  personOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  updateEligibleQualification: PropTypes.func,
};

export default EligibleQualification;
